import { AbstractResizer } from 'abstractModule'
import {
	Admin,
	AlertDashboard,
	AlertDetail,
	AlertAppeal,
	BlockHelps,
	Creator,
	Editor,
	Charts,
	CrossTable,
	Drawer,
	Figures,
	FileManager,
	Filter,
	Header,
	Menu,
	Resizer,
	Tracking,
	FeedbackDetail,
	PasswordManager,
	StickyBlock,
	PdfExport,
	FeedbackMessenger,
	ActionPlanner,
} from 'modules'
import { DataGrid } from '@/modules/dataGrid'

export const Modules = (() => ({
	abstractResizer: AbstractResizer,
	alertDashboard: AlertDashboard,
	alertDetail: AlertDetail,
	alertAppeal: AlertAppeal,
	blockHelps: BlockHelps,
	creator: Creator,
	editor: Editor,
	admin: Admin,
	crossTable: CrossTable,
	charts: Charts,
	drawer: Drawer,
	figures: Figures,
	fileManager: FileManager,
	filter: Filter,
	header: Header,
	menu: Menu,
	resizer: Resizer,
	tracking: Tracking,
	feedbackDetail: FeedbackDetail,
	passwordManager: PasswordManager,
	stickyBlock: StickyBlock,
	pdfExport: PdfExport,
	feedbackMessengerWindow: FeedbackMessenger,
	actionPlanner: ActionPlanner,
	dataGrid: DataGrid,
}))()
